module.exports = __webpack_public_path__ + "static/media/my-circle.ff6584da.svg";